<footer class="footer expandFooter">
    <div class="d-sm-flex justify-content-center justify-content-sm-between px-4 py-2">
        <div class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright &copy; {{CurrentDate}} <a>Wolters Kluwer Financial Services,</a> Inc. and/or its affiliates. All rights reserved. </div>
    </div>
</footer>